//#region src/customer_identifier_input_method.ts
var CustomerIdentifierInputMethod = /* @__PURE__ */ function(CustomerIdentifierInputMethod) {
	CustomerIdentifierInputMethod[CustomerIdentifierInputMethod["AutoGenerated"] = 1] = "AutoGenerated";
	CustomerIdentifierInputMethod[CustomerIdentifierInputMethod["GuestName"] = 2] = "GuestName";
	CustomerIdentifierInputMethod[CustomerIdentifierInputMethod["TableTentPicker"] = 3] = "TableTentPicker";
	CustomerIdentifierInputMethod[CustomerIdentifierInputMethod["TableTrackerPicker"] = 4] = "TableTrackerPicker";
	CustomerIdentifierInputMethod[CustomerIdentifierInputMethod["NumericTextField"] = 5] = "NumericTextField";
	CustomerIdentifierInputMethod[CustomerIdentifierInputMethod["VehicleNameMakeModelColorForm"] = 6] = "VehicleNameMakeModelColorForm";
	CustomerIdentifierInputMethod[CustomerIdentifierInputMethod["AddressForm"] = 7] = "AddressForm";
	CustomerIdentifierInputMethod[CustomerIdentifierInputMethod["PhoneNumberForm"] = 8] = "PhoneNumberForm";
	CustomerIdentifierInputMethod[CustomerIdentifierInputMethod["EmailForm"] = 9] = "EmailForm";
	return CustomerIdentifierInputMethod;
}(CustomerIdentifierInputMethod || {});
//#endregion
export { CustomerIdentifierInputMethod };

//# sourceMappingURL=customer_identifier_input_method.js.map